import theme from '../../theme';

// Card shell plus header/title/stat blocks shared by RouteOperations/RouteCard
// (rc-*) and DispatchTab/DispatchRouteCard (drc-*). Keyed by prefix so each
// card keeps its own class namespace; each spreads this base and adds its own
// extra classes (same pattern as MonitoringTab/popupCardStyles).
export default function routeCardBase(prefix) {
  return {
    background: theme.colors.bgCard,
    border: theme.borders.card,
    borderRadius: theme.radii.card,
    marginBottom: theme.spacing.sectionGap,
    overflow: 'hidden',

    [`& .${prefix}-header`]: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing.fieldGap,
      padding: theme.spacing.bodyPadding,
      userSelect: 'none',
      borderBottom: `1px solid ${theme.colors.borderLight}`,
    },
    [`& .${prefix}-title`]: {
      fontSize: theme.typography.sectionHeader.fontSize,
      fontWeight: theme.fontWeights.semibold,
      color: theme.colors.textDark,
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    [`& .${prefix}-stat`]: {
      fontSize: theme.sizes.smallFontSize,
      color: theme.colors.textMuted,
      whiteSpace: 'nowrap',
    },
    [`& .${prefix}-stat strong`]: {
      color: theme.colors.textDark,
      fontWeight: theme.fontWeights.semibold,
    },
  };
}
